import { useGetImportFormat } from "../../hooks/import/school/useGetImportFormat";

/**
 * Reusable component to download an import template CSV.
 *
 * @param {Object} props
 * @param {"students"|"teachers"} props.type - Template type to download
 * @param {string} props.buttonMessage - Text to display on the link
 */
const DownloadTemplate = ({ type, buttonMessage }) => {
    const { downloadTemplate, loading, error } = useGetImportFormat();

    return (
        <div>
            <div
                className="text-decoration-underline"
                style={{
                    cursor: loading ? "not-allowed" : "pointer",
                    color: "var(--text-color)",
                    opacity: loading ? 0.6 : 1,
                }}
                role="button"
                tabIndex={0}
                onClick={() => {
                    if (!loading) {
                        downloadTemplate(type);
                    }
                }}
                onKeyDown={(e) => {
                    if ((e.key === "Enter" || e.key === " ") && !loading) {
                        e.preventDefault();
                        downloadTemplate(type);
                    }
                }}
            >
                {loading ? "Downloading..." : buttonMessage}
            </div>
            {error && (
                <div className="custom-error mt-1" style={{ fontSize: "0.85rem" }}>
                    {error}
                </div>
            )}
        </div>
    );
};

export default DownloadTemplate;
